import React from 'react';
import { Info } from 'lucide-react';

interface PetQuestionProps {
  isOpen: boolean;
  onClose: () => void;
  onHasPets: () => void;
  onNoPets: () => void;
}

const PetQuestion: React.FC<PetQuestionProps> = ({ isOpen, onClose, onHasPets, onNoPets }) => {
  if (!isOpen) return null;

  const handleNoPets = () => {
    onNoPets();
    onClose();
  };

  const handleHasPets = () => {
    onHasPets();
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" style={{ pointerEvents: 'auto' }}>
      {/* Prevent closing when clicking backdrop - user must choose an option */}
      <div
        className="relative max-w-md w-full"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Outer container with gray background and border */}
        <div className="bg-gray-100 border border-gray-300 rounded-lg p-2 shadow-2xl">
          {/* Inner white container - no close button; modal is not exitable until user answers */}
          <div className="bg-white rounded-lg overflow-hidden">
            {/* Header with icon and title */}
            <div className="flex items-center gap-2 p-4 pb-2">
              <div className="w-5 h-5 text-blue-600">
                <Info className="w-full h-full" />
              </div>
              <h2 className="text-base font-semibold text-gray-900">
                Do you have any pets?
              </h2>
            </div>

            {/* Description text */}
            <div className="px-5 pb-4">
              <p className="text-sm text-gray-600 leading-5">
                Let us know if you have any pets that need to be registered for your property.
              </p>
              <p className="text-sm text-gray-600 leading-5 mt-2">
                You can always add pets later from your dashboard
              </p>
              <p className="text-sm text-gray-700 font-medium mt-3">
                Please select an option below to continue.
              </p>
            </div>

            {/* Action buttons - stack on small screens, touch-friendly */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end gap-2 p-4 pt-2">
              <button
                onClick={handleNoPets}
                className="min-h-[44px] px-4 py-2.5 bg-white border border-gray-300 text-gray-700 rounded-full text-xs font-medium uppercase tracking-wide hover:bg-gray-50 transition-colors shadow-sm"
              >
                I Don't Have Any Pets
              </button>
              <button
                onClick={handleHasPets}
                className="min-h-[44px] px-4 py-2.5 bg-[color:var(--pmc-primary)] text-white rounded-full text-xs font-bold uppercase tracking-wide hover:shadow-lg transition-all"
              >
                Yes, I Have Pets
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PetQuestion;
